'use client';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center p-8 bg-white shadow-md rounded-lg">
        <h1 className="text-4xl font-bold text-red-600 mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-2">Page non trouvée</h2>
        <p className="text-gray-600 mb-4">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <a
          href="/"
          className="inline-block px-6 py-3 bg-primary text-white rounded hover:bg-secondary transition-colors"
        >
          Retour à l'accueil
        </a>
      </div>
    </div>
  );
} 